import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatIconModule } from '@angular/material/icon';
import { Component, inject } from '@angular/core';

import { LoggerService } from '../../shared/services/logger.service';
import { RulesComponent } from '../rules/rules.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  animations: [
    trigger('fullBanner', [
      state(
        'full',
        style({
          'min-height': '650px',
          opacity: 1,
        })
      ),
      state(
        'banner',
        style({
          'min-height': '2.9rem',
          height: '2.9rem',
          opacity: 0.9,
          // 'padding-bottom': 'calc(10rem - 186px)'
        })
      ),
      transition('full <=> banner', [animate('400ms ease-out')]),
    ]),
  ],
  imports: [MatIconModule, MatButtonModule, RulesComponent],
})
export class IntroComponent {
  public canShare = window.navigator.share ? true : false;
  private logger = inject(LoggerService);

  constructor() {}

  scroll(el: HTMLElement): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  shareApp(): void {
    if (window.navigator.share) {
      window.navigator
        .share({
          title: 'BolCó 2026',
          url: 'https://bolco.com.br',
        })
        .then(() => {
          this.logger.debug('Intro:Shared');
        })
        .catch(err => this.logger.error({ 'Intro:Share': err }));
    } else {
      this.logger.debug('Intro:NoShare');
    }
  }
}
